import React from 'react'
import { Layout, Form, Input, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { FormInstance } from "antd/lib/form";
import message from 'antd/lib/message'
import styled from 'styled-components'
import { useLocalStorage } from 'react-use'

import axios from 'src/utils/request'
import Services from 'src/services'
import { useUserState } from 'src/hooks'

const { Content } = Layout
const ContentStyled = styled(Content)`
    display: flex;
    height: 100vh;
    align-items: center;
`

const LoginWrap = styled.div`
    width: 400px;
    margin: 0 auto;
    background: #fff;
    padding: 40px;
`

const Submit = styled(Button)`
    width: 100%
`

const H1 = styled.h1`
    color: #5095eb;
    text-align: center;
    display: block;
    font-weight: 800;
    font-size: 30px;
    padding: 0 0 20px 0;
`


const Login = (props: any) => {
    const [formRef] = React.useState(React.createRef<FormInstance>());
    const [loading, setLoading] = React.useState<boolean>(false)
    const [, setUserState] = useUserState()
    const [, setUserStorage] = useLocalStorage('user', {})
    const history = useHistory()

    const onFinish = (data: any) => {
        setLoading(true)
        Services.user
            .login(data)
            .then(({token}: {token: string}) => {
                
                setUserState({
                    isLogin: true,
                    token
                })

                setUserStorage({token})

                axios.setHeader({
                    Authorization : 'Bearer ' + token
                })
                
                
                history.push('/sdk/android')

                message.success('登录成功')
            })
            .catch((e: AxiosResponse) => {
                // setAlert({
                //     type: 'error',
                //     message: '错误',
                //     description: e.data.msg
                // })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return <Layout>
        <Layout>
            <ContentStyled>
                <LoginWrap>
                    <Form ref={formRef} name="control-ref" onFinish={onFinish}>
                        <H1>TradPlus Docs Admin</H1>
                        <Form.Item
                            name="email"
                            rules={[{ required: true, message: 'Please input email!' }]}
                        >
                            <Input placeholder="Email" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Please input password!' }]}
                        >
                            <Input type="password" placeholder="Password" />
                        </Form.Item>
                        <Form.Item >
                            <Submit type="primary" loading={loading} htmlType="submit">
                                提交
                            </Submit>
                        </Form.Item>
                    </Form>
                </LoginWrap>
            </ContentStyled>
        </Layout>
    </Layout>
}

export default Login